import { PrizeDisplayGroup, PrizeStatus } from '@daymade/common-lib/dbEnums';
import { ZPrizeImageLocations } from '@daymade/common-lib/dbJsonModels';
import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { z } from 'zod';
import {
  zodInsertPrize,
  zodInsertProductCatalog,
  zodSelectPrize,
  zodSelectPrizeTier,
  zodSelectProductCatalog,
} from '../generated/zodSchemas.generated';

export const PrizeStatusEnum = PrizeStatus;

export const ZPrizeSelect = zodSelectPrize.extend(
  ensureSubsetOfKeys(
    zodSelectPrize.shape,
    // WORKAROUND: drizzle-zod not inferring json field's type
    {
      createdAt: z.coerce.date(),
      updatedAt: z.coerce.date(),
      imageLocations: ZPrizeImageLocations,
      seoImageAltText: z.object({
        main: z.string(),
        secondary1: z.string().optional(),
        secondary2: z.string().optional(),
      }),
      internalInfo: z.record(z.string(), z.string()),
      additionalQuestionsForPlayer: z.record(z.string(), z.string()),
    },
  ),
);
export const ZPrizeInsert = zodInsertPrize.extend(
  ensureSubsetOfKeys(
    zodInsertPrize.shape,
    // WORKAROUND: drizzle-zod not inferring json field's type
    {
      imageLocations: ZPrizeImageLocations,
      seoImageAltText: z.object({
        main: z.string(),
        secondary1: z.string().optional(),
        secondary2: z.string().optional(),
      }),
      internalInfo: z.record(z.string(), z.string()),
      additionalQuestionsForPlayer: z.record(z.string(), z.string()),
    },
  ),
);

export const ZAutoFulfilmentDetail = z.object({
  GIFTCLOUD_REWARD: z
    .object({
      code: z.string().optional(),
      customCampaignId: z.string().optional(),
      denomination: z.number().optional(),
      giftIds: z.string().uuid().array().optional(),
    })
    .optional(),
});

export const ZProductSelect = zodSelectProductCatalog.extend(
  ensureSubsetOfKeys(zodSelectProductCatalog.shape, {
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    autoFulfilmentDetail: ZAutoFulfilmentDetail,
  }),
);
export const ZProductInsert = zodInsertProductCatalog.extend(
  ensureSubsetOfKeys(zodInsertProductCatalog.shape, {
    price: z.coerce.number().optional(),
    autoFulfilmentDetail: ZAutoFulfilmentDetail.optional(),
  }),
);

export const ZPrizeCore = ZPrizeSelect.pick({
  id: true,
  slug: true,
  title: true,
  subheading: true,
  isFromPlayersSuggestion: true,
}).extend({
  heroImageLocation: z.string(),
});
export type TPrizeCore = z.infer<typeof ZPrizeCore>;

export const ZDashboardPrize = z.object({
  prizeInstanceId: z.number(),
  title: z.string(),
  subheading: z.string(),
  slug: z.string(),
  heroImageLocation: z.string(),
});

export type TPrizeTier = z.infer<typeof zodSelectPrizeTier>;

export const ZPrizeDisplayGroup = z.nativeEnum(PrizeDisplayGroup);

export type PrizeSearchCursor =
  | {
      mode: 'search';
      rank: number;
      sortOrder: number;
      tierValue: number;
      id: number;
    }
  | { mode: 'browse'; createdAt: string; id: number };

export const ZGetWishlistSuggestions = ZPrizeCore.array();

export type TGetWishlistSuggestions = z.infer<typeof ZGetWishlistSuggestions>;
